import Robot from './robotbase'


class Robotiq140 extends Robot {
	constructor() {
		super('Robotiq140', 'robotiq_2f_140_gripper_visualization', 'urdf/robotiq_arg2f_140_model.xacro');

		this.robotRoot = 'robotiq_arg2f_base_link';
		this.handRoot = 'robotiq_arg2f_base_link';
		this.modelScale = 10;

		this.tcp.parent = 'robotiq_arg2f_base_link';
		this.tcp.position = [0, 0, 0.16];
		this.hand.invertOpenClose = true;
	}
}

module.exports = new Robotiq140();